import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Accordion, Box, BoxProps, Checkbox, HStack, Tag, Text, VStack } from '@chakra-ui/react';
import { Tooltip } from '@src/components/chakra-ui/tooltip';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { Term } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useEffect, useState } from 'react';
type TaxonomyTermSelectorProps = {
  containerProps?: BoxProps;
  onChange?: (selectedTerms: Term[]) => void;
  selectedTermSlugs?: string[];
  showAll?: boolean;
};
export const TaxonomyTermCheckboxList = props => {
  const $ = _c(38);
  let t0;
  if ($[0] !== props.selectedTermSlugs) {
    t0 = props.selectedTermSlugs || [];
    $[0] = props.selectedTermSlugs;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [selectedTermSlugs, setSelectedTermSlugs] = useState(t0);
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = gql`
      query {
        terms(where: { isPrimary: true, isLexicon: false }) {
          id
          name
          slug
          color {
            hex
          }
        }
      }
    `;
    t2 = {
      ssr: false
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const query = useQuery(t1, t2);
  query.data?.terms || [];
  let t3;
  if ($[4] !== props || $[5] !== query.data || $[6] !== selectedTermSlugs) {
    t3 = () => {
      if (query.data?.terms && props.onChange) {
        props.onChange(query.data.terms.filter(t => selectedTermSlugs.indexOf(t.slug) !== -1));
      }
    };
    $[4] = props;
    $[5] = query.data;
    $[6] = selectedTermSlugs;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = query.data?.terms;
  let t5;
  if ($[8] !== selectedTermSlugs || $[9] !== t4) {
    t5 = [selectedTermSlugs, t4];
    $[8] = selectedTermSlugs;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t3, t5);
  let t6;
  if ($[11] !== selectedTermSlugs) {
    t6 = term => {
      if (selectedTermSlugs.indexOf(term.slug) !== -1) {
        setSelectedTermSlugs(selectedTermSlugs.filter(slug => slug != term.slug));
      } else {
        setSelectedTermSlugs([...selectedTermSlugs, term.slug]);
      }
    };
    $[11] = selectedTermSlugs;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const toggleTerm = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["item-0"];
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      bgColor: "transparent"
    };
    t9 = {
      bgColor: "transparent"
    };
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: "colorPalette.fg",
      boxSize: 4
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Text fontSize="0.8em" textStyle="labelSm">Topics</Text>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== query.data?.terms || $[19] !== selectedTermSlugs) {
    t12 = selectedTermSlugs.length > 0 && <HStack gap={2} overflow="auto">{selectedTermSlugs.map(slug_0 => {
        const term_0 = query.data?.terms?.find(t_0 => t_0.slug == slug_0);
        return term_0 ? <TermLetterLink key={term_0.name} term={term_0} /> : <></>;
      })}</HStack>;
    $[18] = query.data?.terms;
    $[19] = selectedTermSlugs;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <HStack align="center" justify="flex-start" width="full">{t11}{t12}</HStack>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Accordion.ItemIndicator />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13) {
    t15 = <Accordion.ItemTrigger _expanded={t8} _hover={t9} padding={0} textStyle="md" _icon={t10}>{t13}{t14}</Accordion.ItemTrigger>;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== query.data || $[27] !== selectedTermSlugs || $[28] !== toggleTerm) {
    t16 = query.data?.terms && <VStack align="flex-start" gap={4} marginBottom={4} width="full">{query.data.terms.map(term_1 => <Box key={term_1.slug} width="full"><NavLink isActive={selectedTermSlugs.indexOf(term_1.slug) !== -1} term={term_1} onClick={term_2 => toggleTerm(term_2)} /></Box>)}</VStack>;
    $[26] = query.data;
    $[27] = selectedTermSlugs;
    $[28] = toggleTerm;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <Accordion.ItemContent paddingBottom={0} paddingTop={4} paddingX={0}><Accordion.ItemBody>{t16}</Accordion.ItemBody></Accordion.ItemContent>;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t15 || $[33] !== t17) {
    t18 = <Accordion.Root collapsible={true} defaultValue={t7}><Accordion.Item border="none" boxShadow="none" value="item-0">{t15}{t17}</Accordion.Item></Accordion.Root>;
    $[32] = t15;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== props.containerProps || $[36] !== t18) {
    t19 = <SSRGate disableSSR={true}><Box {...props.containerProps}>{t18}</Box></SSRGate>;
    $[35] = props.containerProps;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
};
type NavLinkProps = {
  bgColor?: string;
  isActive?: boolean;
  onClick: (term: Term) => void;
  term?: Term;
};
const NavLink = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <HStack borderRadius="md" cursor="pointer" display="flex" transition="all 0.2s ease-in">{props.term === null ? <Text width="full" onClick={() => props.onClick(props.term)}>All</Text> : <Checkbox.Root checked={props.isActive ? true : false} variant="solid" onCheckedChange={() => props.onClick(props.term)}><Checkbox.HiddenInput /><Checkbox.Control borderColor="colorPalette.fg/30"><Checkbox.Indicator /></Checkbox.Control><Checkbox.Label><Text fontSize="sm" fontWeight="medium" width="full">{props.term.name}</Text></Checkbox.Label></Checkbox.Root>}</HStack>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
type TermLetterLinkProps = {
  term: Term;
};
const TermLetterLink = props => {
  const $ = _c(8);
  const t0 = props.term.name;
  const t1 = props.term.color?.hex || "container";
  let t2;
  if ($[0] !== props.term.name) {
    t2 = props.term.name.split(" ").map(_temp);
    $[0] = props.term.name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Tag.Root bgColor={t1} borderRadius="full" fontSize={10} fontWeight="700" lineHeight={1} minWidth="1em" paddingBottom="0.35em" paddingTop="0.45em" paddingX="0.6em" size="sm" textAlign="center" variant="solid">{t2}</Tag.Root>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.term.name || $[6] !== t3) {
    t4 = <Tooltip content={t0} showArrow={true}>{t3}</Tooltip>;
    $[5] = props.term.name;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(word) {
  return word.substring(0, 1).toUpperCase();
}